module.exports = __webpack_public_path__ + "files/ecfa46e46fa4e85aeaf2d595d06bb579.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/mattermost_dark.png
// module id = 1139
// module chunks = 59